import React from "react";
import { classNames } from "../../../../helpers/classNames";
import useFetch from "../../../../hooks/useFetch";
import { dashboardCountFront } from "../../../../services/dashboardService";

const ProfileStatistics = () => {
  const { data: dashboardCount } = useFetch({
    dependencies: ["dashboardData"],
    fetchFunction: async () => {
      const res = await dashboardCountFront();
      if (res?.status === 200) {
        return res?.data;
      }
      return [];
    },
  });

  const labelMap = {
    orderCount: { name: "Books", icon: "fa-light fa-box", color: "#fb923c" },
    imageCount: {
      name: "Images",
      icon: "fa-light fa-file-vector",
      color: "#06D6A0",
    },
    subscriptionCount: {
      name: "Plan",
      icon: "fa-light fa-tickets-perforated",
      color: "#4361EE",
    },
    addressCount: {
      name: "Addresses",
      icon: "fa-light fa-house-building",
      color: "#ef427c",
    },
    // transactionCount: { name: "Transactions", icon: "fa-light fa-circle-dollar-to-slot", color: "bg-md-indigo" },
  };

  const statisticsdata = dashboardCount
    ? Object.entries(labelMap).map(([key, { name, icon, color }], index) => ({
        _id: index + 1,
        name,
        data: dashboardCount[key] ?? 0,
        icon,
        color,
      }))
    : [];

  // const statisticsdata = [
  //   { _id: 1, name: "Orders", data: "26", icon: "fa-light fa-box", color: "#fb923c" },
  //   { _id: 3, name: "Pages", data: "486", icon: "fa-light fa-file-vector", color: "#06D6A0" },
  //   { _id: 2, name: "Subscription", data: "16", icon: "fa-light fa-tickets-perforated", color: "#4361EE" },
  //   { _id: 4, name: "Addresses", data: "6", icon: "fa-light fa-house-building", color: "#ef427c" },
  // ];
  return (
    statisticsdata?.length > 0 && (
      <div className="grid grid-cols-2 gap-4">
        {statisticsdata?.map((item, index) => (
          <div
            key={index}
            className="relative bg-white py-3 3xl:py-4 px-3 3xl:px-4 shadow shadow-md-pink/20 rounded-lg"
            style={{ "--statusColor": item?.color }}
          >
            <div className="flex 2xl:items-end justify-between gap-4 2xl:gap-2 flex-col-reverse 2xl:flex-row">
              <div className="flex-shrink flex-grow flex flex-col justify-between 2xl:gap-2">
                <div className="uppercase text-xs font-semibold tracking-wide text-md-dark">
                  {item?.name}
                </div>
                <div
                  className="font-bold text-2xl 2xl:text-4xl tracking-tight !leading-none"
                  style={{ color: "var(--statusColor)" }}
                >
                  {item?.data}
                </div>
              </div>
              <div
                className="relative overflow-hidden z-0 flex-shrink-0 w-12 3xl:w-16 aspect-square flex items-center justify-center text-2xl 3xl:text-3xl bg-white rounded-lg"
                style={{
                  color: "var(--statusColor)",
                  boxShadow: "0 4px 10px -6px var(--statusColor)",
                }}
              >
                <div
                  className="absolute inset-0 z-[-2] rounded-lg opacity-5"
                  style={{ backgroundColor: "var(--statusColor)" }}
                />
                <div
                  className="absolute inset-0 z-[-1] rounded-lg opacity-10"
                  style={{ border: "1px solid var(--statusColor)" }}
                />
                <i className={classNames("fa-fw", item?.icon)}></i>
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  );
};

export default ProfileStatistics;
